var t = /* @__PURE__ */ ((r) => (r.Left = "left", r.Right = "right", r.Center = "center", r.Justify = "justify", r))(t || {});
export {
  t as TextAlignEnum
};
